module.exports = __webpack_public_path__ + "static/media/favorite-filled.4326ee64.svg";